// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.baloa-username.list_dynamic_container_label{
    font-weight: var(--font-medium);
    color: var(--basic-gray-color);
    padding-bottom: var(--space-half);
}

.content-input input,
.content-select select{
	appearance: none;
	-webkit-appearance: none;
	-moz-appearance: none;
}

.content-select select{
	appearance: none;
	-webkit-appearance: none;
	-moz-appearance: none;
}

.content-select select::-ms-expand {
    display: none;
}

.content-select{
	max-width: 40%;
	position: relative;
}

.content-select select {
    display: inline-block;
    width: 100%;
    cursor: pointer;
    padding: 7px 10px;
    background-color: var(--white-color);
    border: 1px solid var(--new-gray-background-color);
    box-sizing: border-box;
    border-radius: 8px;
    position: relative;
    transition: all 0.25s ease;
    font-family: var(--secondary-font);
    font-weight: var(--font-regular);
    line-height: calc( var(--space) + var(--space-quarter) );
    letter-spacing: 0.005em;
    color: var(--basic-gray-color);
    font-size: 14px !important;
}

.content-select select:focus {
    outline: none;
}

.baloa-username.list_dynamic_container_Item{
    color: var(--new-gray-background-color);
    padding-bottom: var(--space-half);
}`, "",{"version":3,"sources":["webpack://./src/app/tournaments/components/dynamic-fields-tournament-form/list-tournament-form/ListDynamicComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,+BAA+B;IAC/B,8BAA8B;IAC9B,iCAAiC;AACrC;;AAEA;;CAEC,gBAAgB;CAChB,wBAAwB;CACxB,qBAAqB;AACtB;;AAEA;CACC,gBAAgB;CAChB,wBAAwB;CACxB,qBAAqB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;CACC,cAAc;CACd,kBAAkB;AACnB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,oCAAoC;IACpC,kDAAkD;IAClD,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,0BAA0B;IAC1B,kCAAkC;IAClC,gCAAgC;IAChC,wDAAwD;IACxD,uBAAuB;IACvB,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uCAAuC;IACvC,iCAAiC;AACrC","sourcesContent":[".baloa-username.list_dynamic_container_label{\n    font-weight: var(--font-medium);\n    color: var(--basic-gray-color);\n    padding-bottom: var(--space-half);\n}\n\n.content-input input,\n.content-select select{\n\tappearance: none;\n\t-webkit-appearance: none;\n\t-moz-appearance: none;\n}\n\n.content-select select{\n\tappearance: none;\n\t-webkit-appearance: none;\n\t-moz-appearance: none;\n}\n\n.content-select select::-ms-expand {\n    display: none;\n}\n\n.content-select{\n\tmax-width: 40%;\n\tposition: relative;\n}\n\n.content-select select {\n    display: inline-block;\n    width: 100%;\n    cursor: pointer;\n    padding: 7px 10px;\n    background-color: var(--white-color);\n    border: 1px solid var(--new-gray-background-color);\n    box-sizing: border-box;\n    border-radius: 8px;\n    position: relative;\n    transition: all 0.25s ease;\n    font-family: var(--secondary-font);\n    font-weight: var(--font-regular);\n    line-height: calc( var(--space) + var(--space-quarter) );\n    letter-spacing: 0.005em;\n    color: var(--basic-gray-color);\n    font-size: 14px !important;\n}\n\n.content-select select:focus {\n    outline: none;\n}\n\n.baloa-username.list_dynamic_container_Item{\n    color: var(--new-gray-background-color);\n    padding-bottom: var(--space-half);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
